export const getChartValues = chartData => {
  const preparedValues = {};
  for (let key in chartData) {
    if (key !== "allowance_months_count" && key !== "allowance_rule" && key !== "default_currency" && key !== "period") {
      preparedValues[key] = chartData[key];
    }
  }
  return preparedValues;
}